export function getPremierAccessData(userInfo) {
    if (!userInfo) {
        return {
            activePremierAccess: false,
            premierAccessRole: null,
            premierAccessLevel: null,
            limitedPremierAccess: false,
        };
    }

    if (typeof userInfo.get === 'function') {
        return {
            activePremierAccess: userInfo.get('activePremierAccess'),
            premierAccessRole: userInfo.get('premierAccessRole'),
            premierAccessLevel: userInfo.get('premierAccessLevel'),
            limitedPremierAccess: userInfo.get('limitedPremierAccess'),
        };
    }

    return {
        activePremierAccess: userInfo.activePremierAccess ?? userInfo.active_premier_access ?? false,
        premierAccessRole: userInfo.premierAccessRole ?? userInfo.premier_access_role ?? null,
        premierAccessLevel: userInfo.premierAccessLevel ?? userInfo.premier_access_level ?? null,
        limitedPremierAccess: userInfo.limitedPremierAccess ?? userInfo.limited_premier_access ?? false,
    };
}

export function hasPremierAccess(userInfo) {
    const { activePremierAccess, premierAccessRole, premierAccessLevel } = getPremierAccessData(userInfo);
    return Boolean(
        activePremierAccess && (
            premierAccessRole === 'admin'
            || (premierAccessRole === 'member' && premierAccessLevel !== 'no_access')
        ),
    );
}

export function hasFullAccess(userInfo) {
    const { premierAccessRole, premierAccessLevel } = getPremierAccessData(userInfo);
    return premierAccessRole === 'admin' || premierAccessLevel === 'full_access';
}

export function hasAnyPremierAccess(userInfo) {
    const { activePremierAccess, limitedPremierAccess } = getPremierAccessData(userInfo);
    return Boolean(activePremierAccess || limitedPremierAccess);
}

export function isDigitalOnly(userInfo) {
    const { activePremierAccess, premierAccessRole, premierAccessLevel, limitedPremierAccess } = getPremierAccessData(userInfo);
    return (
        (activePremierAccess && premierAccessRole !== 'admin' && (
            premierAccessLevel === 'read_only' || premierAccessLevel === 'no_access'
        )) || (!activePremierAccess && limitedPremierAccess)
    );
}

export function canViewSwag(userInfo) {
    if (!userInfo) return false;

    const canView = typeof userInfo.get === 'function' ? userInfo.get('can_view_swag') : (userInfo.can_view_swag ?? userInfo.canViewSwag);
    return Boolean(canView);
}
